// extracted by css-extract-rspack-plugin
export default {"cls1":"ReaderWithLoadedSidebar-cls1_7ZJ","cls2":"ReaderWithLoadedSidebar-cls2_Fzj ReaderWithLoadedSidebar-cls1_7ZJ"};